import React from 'react'

//components
import { BasicButton, IconLibrary, ThriveIcon } from 'thrive-components';
import SingleFactorExternalInfoContainer from './SingleFactorExternalInfoContainer';

//hooks
import { usePasskeySetupNeeded } from './PasskeySetUpNeeded.hook';

//helpers
import { getAddPasskeyLink } from  '@/helpers/OrgSettings';
import { getLoginRelativePath } from  '@/helpers/Auth';


//styling
import "../../../../css/orgSettings/passkeys/passkey-set-up-needed.scss";




const PasskeySetUpNeededPanel = () => {  
    const linkUrl = getAddPasskeyLink();
    const signInUrl = getLoginRelativePath();

    // We have renamed inbound param to mfa session rather than passkey session - passkey will always be mfa=true

    const { userHasPasskeyButIsntUsingIt, isLoading, getBuuttonText, isSingleFactorExternal } = usePasskeySetupNeeded();

    return(<> {isSingleFactorExternal
        ? <SingleFactorExternalInfoContainer />
        : <div className="passkey-set-up-panel">
            <div className="top-panel">
                <ThriveIcon 
                    className='passkey-set-up-icon'
                    iconName={IconLibrary.LOCK}
                    color='var(--thriveCharcoal)'
                    sizeInPx='16'
                />
            
                <span className='boldened-header'>
                    Passkey Authentication Needed
                </span>
            </div>

            <div className='passkey-users-explainer-text'> 
                You need to login with a Passkey on your account before you can manage Passkey settings.
            </div>
    
            {!isLoading && 
                <BasicButton 
                    className='create-passkey-button'
                    content={
                        <>
                            <ThriveIcon 
                                iconName={IconLibrary.USER_PASSKEY} 
                                color='var(--thriveCharcoal)'
                                sizeInPx='12'
                            />
                            { getBuuttonText(userHasPasskeyButIsntUsingIt) }
                        </>
                    } 
                    isLink
                    linkUrl={userHasPasskeyButIsntUsingIt ? signInUrl : linkUrl}
                    ariaLabel={ getBuuttonText(userHasPasskeyButIsntUsingIt) } 
                />
                }
        </div>
    }</>)
}

export default PasskeySetUpNeededPanel